import { Modal } from '@/ui';
import PropTypes from 'prop-types';
import NuevaCausa from './NuevaCausaForm';

// Suscribir-causa modal — a real modal, not a drawer. Wraps the shared
// NuevaCausaForm in the Modal shell; the form keeps owning its own action row.
// Mounted from both Causas (list) and Dashboard (Inicio) — REC-1792.
export default function SuscribirCausaModal({
  open,
  onClose,
  cortes,
  tribunalesPorCorte,
  members,
  canAssign,
  values,
  onChange,
  onClear,
  onSubmit,
  apiError,
  isSubmitting,
}) {
  return (
    <Modal open={open} onClose={onClose} size="default">
      <Modal.Header title="Suscribir causa" onClose={onClose} />
      <Modal.Body>
        <NuevaCausa
          cortes={cortes}
          tribunalesPorCorte={tribunalesPorCorte}
          members={members}
          canAssign={canAssign}
          values={values}
          onChange={onChange}
          onClear={onClear}
          onSubmit={onSubmit}
          onCancel={onClose}
          apiError={apiError}
          isSubmitting={isSubmitting}
        />
      </Modal.Body>
    </Modal>
  );
}

SuscribirCausaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cortes: PropTypes.array,
  tribunalesPorCorte: PropTypes.object,
  members: PropTypes.array,
  canAssign: PropTypes.bool,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  apiError: PropTypes.string,
  isSubmitting: PropTypes.bool,
};
